<div class="navblock">
    <button class="btnadd" (click)="openCreateModal()">{{'Add company'|translate }}</button>
    <div class="inputgroup">
        <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
            (input)="onTermChange($event)" />
    </div>
    <div class="inputgroup company-filter">
        <label class="filter-company-label">{{'Filter by company'|translate}}</label>
        <p-multiselect [options]="objects" [ngModel]="selectedCompanyIds"
            (ngModelChange)="companyFilterChange($event)" optionLabel="Name" optionValue="Id" [filter]="true"
            filterBy="Name" [showClear]="true" [appendTo]="'body'" styleClass="objects-company-multiselect"
            panelStyleClass="objects-company-multiselect-panel"
            [placeholder]="'All companies' | translate"></p-multiselect>
    </div>
</div>
<div class="tablewrap">
    <div class="table">
        <table fixedcols="[0, 1, 5]" id="exporttable">
            <tr>
                <th>
                    <switch-all-checkbox [items]="getFilteredObjects() | groupFilter : filter" />
                </th>
                <th>{{'Company'|translate }}</th>
                <th>{{'Status'|translate}}</th>
                <th>{{'Parent company'|translate}}</th>
                <th>{{'Objects count'|translate}}</th>
                <th>{{'Branch objects count'|translate}}</th>
                <th>{{'Geozones count'|translate}}</th>
                <th class="hidden-print">&nbsp;</th>
            </tr>
            <tr *ngFor="let company of getFilteredObjects() | groupFilter : filter | pagesfilter: pageInfoFilter" [class.checked]="company.IsChecked">
                <td>
                    <input type="checkbox" [(ngModel)]="company.IsChecked" />
                </td>
                <td>{{company.Name}}</td>
                <td>{{getStatus(company)}}</td>
                <td>{{company.ParentCompanyName}}</td>
                <td>{{company.ObjectCount}}</td>
                <td>{{company.ObjectWithSubCompaniesCount}}</td>
                <td>{{company.GeoZoneCount}}</td>
                <td>
                    <button class="btn_img btn_edit" (click)="editCommand(company)" data-toggle="tooltip"
                        data-placement="top" title="{{'Edit'|translate}}"></button>
                    <button class="btn_img btn_trush" (click)="deleteObject(company.Id)"
                        title="{{'Delete'|translate}}"></button>
                </td>
            </tr>
        </table>
    </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [viewMode]="'print excel pages'"
    (onPageChange)="onPageChange($event)" [items]="getFilteredObjects() | groupFilter : filter"></app-footer-component>
<template #mgmtDialog></template>

<script>
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
</script>
